import { Outlet } from 'react-router-dom';

export default function FullscreenRootLayout() {
  return <Outlet />;
}
